import { useApiFeatureFlagsRetrieve } from '../../client/api/api';
import { getMinutesAsMilliseconds } from '../../utils/getMinutesAsMilliseconds';

const staleTime = getMinutesAsMilliseconds(10);

export const useFeatureFlags = () => {
  const { data } = useApiFeatureFlagsRetrieve({
    query: {
      staleTime,
    },
  });
  const getFlag = (flagName: string, defaultValue = false): boolean => {
    if (data === undefined || data[flagName] === undefined) {
      return defaultValue;
    }
    return data[flagName];
  };
  return { getFlag };
};
